"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var FeatureFlagsHeader_1 = require("./FeatureFlags/FeatureFlagsHeader");
var FeatureFlagsList_1 = require("./FeatureFlags/FeatureFlagsList");
var HeaderFlexPane_1 = require("./HeaderFlexPane");
var FeatureFlagsPane = function (props) {
    return (React.createElement(HeaderFlexPane_1.default, { title: "Feature Flags", content: React.createElement("div", null,
            React.createElement(FeatureFlagsHeader_1.default, null),
            React.createElement(FeatureFlagsList_1.default, null)), onDismiss: props.onDismiss }));
};
exports.default = FeatureFlagsPane;
//# sourceMappingURL=FeatureFlagsPane.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/header/owa-header-pane/lib/components/FeatureFlagsPane.js
// module id = 6198
// module chunks = 38